import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import "./content.css";

const TermsConditions = () => {
  return (
    <div className="terms content_page">
      <Breadcrumb name={"Terms & Conditions"} pageName={"Terms & Conditions"} />
      <div className="terms-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="terms-info-wraps">
                <h4 className="title">
                Classhila Education Private Limited- Subscription
                Terms and Conditions
                </h4>

               <p>Welcome to the terms and conditions for the usage of the Classhila Education
Private Limited Subscription. These terms are between you and Classhila Education
Private Limited. We request you to read these terms, along with the Privacy Policy,
Terms and conditions of usage, and all other policies and rules made available on
the Classhila platform or mobile application (including, but not limited to, any rules or
usage provisions specified on any page or on any help or other informational page
on Classhila website or mobile application). Every time you visit, browse or use your
Classhila Subscription, you accept this Agreement.</p>
<h4>Eligibility &amp; Subscription</h4>
<p>Classhila Subscription (&quot;Subscription Service&quot;) is a personalized offering designed to
help you discover and engage with digital educational content created and live-
streamed by top educators (&quot;Educational Content&quot;) in your chosen categories of
interest. You can access the Subscription Service and Educational Content through
the Classhila website or mobile application by selecting a subscription plan of your
choice (“Subscription”). The Subscription grants access to all ongoing courses and
classes within the chosen category during your subscription period. If you are under
18 years of age or below the age of majority in your region, you may use the
Subscription only with the involvement of a parent or guardian. As part of the
Subscription, we personalize content and features, including recommendations for
Educational Content in your subscribed category and related categories of potential
interest. Additionally, we strive to continuously enhance the Subscription and its
plans to improve your overall experience.</p>
<h4>B. Compatible devices</h4>
<p>To access live-streamed courses or classes and download Educational Content via
the mobile application, you will need a personal computer, portable media player, or
other device that meets the required system and compatibility specifications (a
&quot;Compatible Device&quot;). The list of Compatible Devices may be updated periodically,
and whether a device qualifies as a Compatible Device may depend on software or
systems maintained by the device manufacturer or other third parties. Consequently,
a device that is initially a Compatible Device may no longer meet compatibility
requirements in the future. Therefore, please ensure that your device remains
compatible with our system and software to fully utilize the Subscription Service.</p>
<h4>C. Educational content</h4>

<ol>
  <li>The Subscription allows you to access live-streaming of Educational Content on a
subscription basis in the subscripted category for viewing, for a limited period of time
during the Subscription Period.</li>
  <li><h5>Usage Rules:</h5>
  <p>Due to restrictions set by our Educational Content providers, including Educators,
the Educational Content available through the Classhila Subscription is subject to
limitations on viewing access and the duration for which it remains accessible. These
restrictions may evolve as we introduce new features, devices, and content to our
Subscription Service. Below are the current limitations for accessing Educational
Content on Classhila Subscription:</p>
  </li>
 
</ol>
<ol>
  <li>
<h5>Live – Streaming of Education Content:</h5>
<p>During your subscription period, you shall get access to attend live- streamed
classes/courses of the Educational Content within your subscribed category through
your Web browser/mobile application through compatible Internet-connected
devices.</p>
  </li>


  <li>
<h5>Downloading:</h5>
<p>You may only download Educational Content through the in-app download feature,
which can be accessed on your compatible devices during the Subscription Period.
Once downloaded, the Educational Content will remain accessible to you only for the
duration of your Subscription. Access to all downloaded content will be revoked upon
the expiry or termination of your Subscription, as applicable.</p>
  </li>
  <li>
<h5>Viewing Period:</h5>
<p>You can attend live-streamed courses or classes of the Educational Content and re-
watch them later during your Subscription Period by streaming or downloading them
through the app. You may do so as frequently as you wish and for as long as you
like, provided your subscription remains active and the viewing occurs within the
Subscription Period or any additional timeframe specified in this Agreement.</p>
  </li>


  <li>
<h5>Subscription &amp; Payment:</h5>
<p>Subscribe to your preferred category by clicking &#39;Subscribe&#39; option and making the
required payment for your chosen subscription plan.</p>
  </li>


  <li>
<h5>Limited License to Educational Content:</h5>
<p>Upon payment of the Subscription fee and compliance with the terms of this
Agreement, Classhila and the Educator grant you a non-exclusive, non-transferable,

non-sublicensable, limited license to access, view, and attend live-streamed classes
or courses of the Educational Content during the applicable Subscription Period.
This license is for your personal, non-commercial, and private use only. Access to
the Educational Content may be automatically revoked from your Compatible Device
at the end of the Subscription Period or as outlined in this Agreement.</p>
  </li>


  <li>
<h5>Availability of Subscribed Educational Content:</h5>
<p>During the Subscription Period, you will generally have access to Educational
Content for in-app download, streaming, or attending live-streamed classes/courses,
during the Subscription Period, as applicable, but may become unavailable due to
potential Educator licensing restrictions or for other reasons. However, this content
may become unavailable due to Educator licensing restrictions or other reasons, and
Classhila will not be responsible if the subscribed Educational Content is no longer
accessible for download or streaming. You may download and store your own copy
of the Educational Content on a Compatible Device authorized for in-app downloads.
However, access to such downloaded content will be revoked upon the expiry of the
Subscription Period, in the event of Educator licensing restrictions, or if the
Subscription is terminated in accordance with this Agreement&#39;s terms.</p>
  </li>




  <li>
<h5>In-App Downloading:</h5>
<p>You are granted a license solely for in-app downloads of the Educational Content
within the mobile application or on an authorized Compatible Device. Any attempt to
screen-cast or download the content onto unauthorized devices or by methods not
permitted under these terms will result in the immediate termination of your
Subscription and access to all downloaded Educational Content. Classhila also
reserves the right to take appropriate legal action at its sole discretion.</p>
  </li>


  <li>
<h5>Quality of Streaming:</h5>
<p>The resolution and quality of the Educational Content you access may vary based on
several factors, including the type of Compatible Device on which you are accessing
the Educational Content and and your internet bandwidth, which can increase or
decrease during viewing of the course. While we aim to deliver a high-quality viewing
experience, we cannot guarantee the resolution or quality of the Educational Content
you will receive when streaming.</p>
  </li>


  


  <li>
<h5>General Restrictions:</h5>
<p>You are prohibited from: (i) transferring, copying, or displaying the Educational
Content, except as authorized under this Agreement; (ii) selling, renting, leasing,
distributing, or broadcasting any rights to the Educational Content; (iii) removing any
proprietary notices or labels from the Educational Content; (iv) attempting to disable,
bypass, modify, defeat, or otherwise circumvent any digital rights management or

content protection system associated with the Subscription; or (v) using the
Subscription or Educational Content for any commercial or unlawful purposes.</p>
  </li>

</ol>
<h4>D. Additional terms</h4>
<ol className="inline_b">
  <li>
<b>Communications:</b>
<p> We may communicate with you electronically, including through
email and push notifications, to send promotions or other updates. By using our
services, you consent to receive these communications, which will comply with the
Classhila Privacy Policy.</p>
  </li>


  <li>
<b>Modification of Subscription:</b>
<p> Classhila reserves the right to modify, suspend, or
discontinue the Subscription Service, or any part thereof, at any time without prior
notice (unless required by applicable law). Classhila will not be liable for any
consequences arising from such actions, even if they affect your ability to access or
use Educational Content.</p>
  </li>



  <li>
<b>Amendments:</b>
<p> Classhila reserves the right to make changes to this Agreement at
any time by posting the revised terms associated with the Subscription Service. To
the fullest extent permitted by law, your continued use of the Subscription Service
after such changes are made will constitute your acceptance of the updated terms.</p>
  </li>


  <li>
<b>Reservation of Rights; Waiver: </b>
<p> The Subscription Service and the Educational
Content embody intellectual property that is protected by law.
The Educators, as copyright owners of the Educational Content, are intended third-
party beneficiaries of this Agreement. Our decision not to insist on or enforce strict
compliance with the Agreement does not waive any of our rights.</p>
  </li>
  <li><b>Disputes/Conditions of Use:</b>
  <p> Any disputes or claims related to this Agreement or
the Subscription Service are governed by the applicable laws, disclaimers of
warranties, limitations of liability, binding arbitration provisions, and other terms
outlined in the Classhila Terms of Use. By using the Subscription Service, you agree
to these terms.</p>
  </li>
  <li><b>Limitation of Liability:</b>
  <p>Without limiting the disclaimers of warranties and limitations
of liability outlined in the Classhila Terms of Use: (i) our total liability to you for all
damages arising from or related to your use or inability to use the Subscription
Service shall not exceed INR 500 (Indian Rupees Five Hundred); and (ii) the
combined total liability of Classhila and its Educational Content providers (i.e.,
Educators) for all damages arising from your use of the Subscription Service, the
Educational Content, or any related information or materials shall also not exceed
INR 500 (Indian Rupees Five Hundred). These limitations apply even if the provided
remedies fail to fulfill their essential purpose.</p></li>
<li><b>Contact Information:</b>
<p> For communications concerning this Agreement, please write
to Classhila at <a href="mailto:help.classhila@gmail.com">  support@classhila.com.</a></p>
</li>
  </ol>









              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
